<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { LegacyDropdown } from '@athena-lib/Fields';
  import type { SiteSelectorProps } from './types';
  let { sites, onChangeSite }: SiteSelectorProps = $props();
  let value = $state('');
  const translations = getCommonTranslations();

  $effect(() => {
    value = window.location.origin + '/';
  });
</script>

<div>
  <LegacyDropdown
    {value}
    label={translations.siteSelector}
    variant="ghost"
    options={sites.map((s) => ({ key: s.url, value: s.name }))}
    optionClassName="bg-st-black"
    onChange={(url) => {
      const site = sites.find((s) => s.url === url);
      if (site) {
        onChangeSite(site);
      }
    }}
  />
</div>
